import React from 'react';
import Radium from 'radium';

import Modal from 'react-responsive-modal';

import { Formik } from 'formik';
import Yup from 'yup';
import {Input, SubmitButton, RGForm, TextArea, ComboBox, Checkbox} from 'views/FormElements';
import {Img} from 'views/AppElements';

import AppConstants from 'AppConstants';

import {StockAction} from 'AppAction';
import StockStore from 'stores/StockStore';

import OrderAPI from 'service/api/OrderAPI';
import StockAPI from 'service/api/StockAPI';

import Dispatcher from 'service/Dispatcher';
import AppUtil from '../../AppUtil';

const ORDER_STATE = AppConstants.ORDER_STATE;

const VALIDATE_TO_ORDER_STATES = {"ORDER_PLACED": [ORDER_STATE.ORDER_CONFIRMED, ORDER_STATE.CANCELLED],
								"ORDER_CONFIRMED": [ORDER_STATE.CANCELLED, ORDER_STATE.SHIPPING, ORDER_STATE.DELIVERED],
								"SHIPPING": [ORDER_STATE.CANCELLED, ORDER_STATE.DELIVERED],
                                "CANCELLED": [ORDER_STATE.SHIPPING],
                                "DELIVERED": [ORDER_STATE.DELIVERED_CLOSED]
                                };
                      
class ChangeOrderStateModalForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {openModal: true};
        
        this.getInitValues = this.getInitValues.bind(this);
        this.handleFormSubmission = this.handleFormSubmission.bind(this);
        this.showStockProductInputs = this.showStockProductInputs.bind(this);
        this.validationScheme = this.validationScheme.bind(this);
    }


    getInitValues() {
        const order = this.props.order;
        return {orderId: order.orderId,
                orderState: order.orderState,
                cancelledReason: order.cancelledReason? order.cancelledReason: '',

                productSize: order.productSizes.map(s => {
                                    const sizeMetaData = order.sizeMetaData || AppUtil.getSizeInfo(order.product);
                                    const size = sizeMetaData[s];
                                    if(!size)
                                        return s;
                    
                                    return size.label;
                                }).toString(),
                stockOwner: '',
                stockProduct: '',
                noStockDeduction: false
                };
    }

    showStockProductInputs() {
        const order = this.props.order;
        return order.orderState !== ORDER_STATE.ORDER_PLACED.value 
                                        && order.orderState !== ORDER_STATE.CANCELLED.value 
                                        && !order.stockProductId;
    }

    componentWillReceiveProps(nextProps) {
        this.setState({openModal: true})
    }

    validationScheme() {
        const validation = {
                            orderState: Yup.string().required("Select New State"),
                            cancelledReason: Yup.string().when('orderState', (orderState, schema) => {
                                    return orderState === ORDER_STATE.CANCELLED.value? Yup.string().required("Specify cancelled reason."): Yup.string();
                                }),
                            noStockDeduction: Yup.boolean(),
                            stockProduct: Yup.boolean().when('noStockDeduction', (noStockDeduction, schema) => {
                                if(noStockDeduction === false) {
                                    if(this.showStockProductInputs())
                                        return Yup.string().required("Select Stock Product to update");
                                }
                                
                                return Yup.string();
                            })
                        };
        
        return Yup.object().shape(validation);
    }

    handleFormSubmission(formValue, {setSubmitting, resetForm}) {
        const newState = formValue.orderState;
		const order = this.props.order;

		const stockProductId = formValue.stockProduct;

		var confirmRes = confirm("Are you sure you want to update this order state to "+newState+"?");

		if(confirmRes === false) {
			setSubmitting(false);
			resetForm();
			return;
		}
		
		if(newState === ORDER_STATE.CANCELLED.value) {
			OrderAPI.cancelOrder(order, formValue.cancelledReason, stockProductId, function(success) {
				//on success the row is removed
				if(success === false) {
					setSubmitting(false);
					resetForm();
				} else {
                    if(stockProductId) {
                        Dispatcher.dispatch({
                            type: StockAction.CLEAR_OWNER_STOCKS,
                            stockOwner: formValue.stockOwner
                        });
                    }
                    
                    this.props.onClose();
                }
			}.bind(this));
		} else {
			OrderAPI.updateOrderState(order, newState, stockProductId, function(success) {
				//on success the row is removed
				if(success === false) {
					setSubmitting(false);
					resetForm();
				} else {
                    if(stockProductId) {
                        Dispatcher.dispatch({
                            type: StockAction.CLEAR_OWNER_STOCKS,
                            stockOwner: formValue.stockOwner
                        });
                    }
                    
                    this.props.onClose();
                }
			}.bind(this));
		}
    }

    onStockOwnerChange(owner, setFieldValue) {        
        if(!StockStore.getStocks(owner))
            StockAPI.getStocks(owner, function(stocks) {
                //after receiving stocks set owner value again to build the form
                setFieldValue('stockOwner', owner);
            });
    }

    render() {
        const initValues = this.getInitValues();
        const order = this.props.order;

        const validToStates = VALIDATE_TO_ORDER_STATES[order.orderState];

        
        
        return <Modal closeOnOverlayClick={false} open={this.state.openModal} onClose={this.props.onClose} little 
                        classNames={{ overlay: 'add-stock-overlay', modal: 'add-stock-modal' }}>
                    
                    <Formik enableReinitialize initialValues={initValues} onSubmit={this.handleFormSubmission}
                            validationSchema={this.validationScheme} 
                            render={({values, isSubmitting}) => {
                            
                        
                            const stockOwners = StockStore.getStockOwners();
                            const stockOwnerOptions = stockOwners? stockOwners.map(function(o) {
                                return {'value': o.ownerAlias, 'label': o.ownerAlias};
                            }): [];
                            

                            const stockProducts = values.stockOwner? StockStore.getStocks(values.stockOwner): [];

                            const productSizes = AppUtil.getSizeInfo(order.product);
                            
                            const stockProductOptions = stockProducts? stockProducts.filter(sp => sp.product.productType === order.product.productType)
                                                                                    .filter(sp => productSizes[sp.productSize] !== undefined)
                                                                                    .filter(sp => productSizes[sp.productSize].label === values.productSize)
                                                                                    .filter(sp => sp.quantity > 0)
                                                                                    .map(function(sp) {
                    
                                                                                        const label = <div className="flexRow stockProductionOption">
                                                                                                            <span>{sp.product.title +" - "+sp.productSize+" ["+sp.quantity+"]"} </span>
                                                                                                            <img alt={sp.product.title} src={sp.product.previewImage} style={{height: '40px', width: '40px'}} />
                                                                                                    </div>
                                                                                        return {'value': sp.stockProductId, 
                                                                                                'label': label};
                                                                                    }): [];
                            
                            const showStockProductInputs = this.showStockProductInputs() && values.noStockDeduction === false;
                            const sizeLabel  = AppUtil.getOrderSizeString(order, order.product);
                            return <RGForm>
                                    <h2>{order.product.title} - {sizeLabel}</h2>
                                    <label style={{margin: '20px 0 0 0', borderBottom: '1px solid gray', 
                                                display: 'block', fontSize: '120%'}}>Order Id {values.orderId}</label>
                                    <Input type="hidden" name="orderId" disabled={true} />

                                    <ComboBox placeholder="Select New State" name="orderState" value={values.orderState} 
                                            options={validToStates} clearable={false}
                                            style={{flexGrow: '1', margin: '0'}}/>	
                                    <br /> 

                                    {values.orderState === ORDER_STATE.CANCELLED.value &&
                                            <TextArea placeholder="Please Specify why the order was cancelled."  name="cancelledReason" 
                                                        rows="2" style={{width: '100%', marginTop: '10px'}} />
                                        }

                                    {this.props.order.orderState !== ORDER_STATE.ORDER_PLACED.value && !this.props.order.stockProductId &&
                                        <Checkbox name="noStockDeduction" label="No stock deduction" />
                                    }

                                    {showStockProductInputs && 
                                        <div id="stockProductInputs">
                                            <h3 style={{color: 'gray'}}>Deduct Order Stock</h3>

                                            <div className="flexRow" style={{flexWrap: 'nowrap'}}>
                                                <div style={{flexGrow: 1}}>
                                                    <Input type="text" label="Order Size" name="productSize" disabled={true} />

                                                    <ComboBox name="stockOwner" value={values.stockOwner} 
                                                        options={stockOwnerOptions} placeholder={<span>@ Select Stock Owner</span>}
                                                        closeOnSelect={true}
                                                        onComboChange={this.onStockOwnerChange}/>

                                                    <ComboBox name="stockProduct" value={values.stockProduct} 
                                                        options={stockProductOptions}
                                                        placeholder="Select Stock Product"
                                                        closeOnSelect={true} 
                                                        />
                                                </div>
                                                <Img className="stockUpdateImg" src={order.orderedProductImage} />
                                            </div>
                                        </div>
                                    }
                                    
                                    

                                    <SubmitButton color="primary" disabled={isSubmitting}>Update</SubmitButton>
                                </RGForm>
                            }} />
            </Modal>
    }
}


export default Radium(ChangeOrderStateModalForm);


// WEBPACK FOOTER //
// ./src/views/admin/ChangeOrderStateModalForm.js